export enum AsyncTaskStatus {
  IN_PROGRESS = 'In progress',
  COMPLETED = 'Completed',
  WARNINGS = 'Warnings',
  FAILED = 'Failed',
  CANCELED = 'Canceled',
}
